function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled, css } from 'styled-components';
import { StateLayer } from '../../../core-components';
import { DefaultsProvider } from '../../../util';
const StyledContainer = styled.div.withConfig({
  componentId: "aui__sc-tslq2-0"
})(["overflow:hidden;position:relative;border-radius:var(--aui-border-radius-round);width:1.5rem;height:1.5rem;margin:var(--aui-spacing-050);padding:var(--aui-spacing-100);[data-aui='icon']{vertical-align:baseline;}"]);
const StyledTouchBox = styled.div.withConfig({
  componentId: "aui__sc-tslq2-1"
})(["all:unset;cursor:default;display:flex;&:hover ", "{opacity:var(--aui-state-layer-hover);}", ""], StateLayer, ({
  $hasAction
}) => $hasAction && css(["cursor:pointer;&:active ", "{opacity:var(--aui-state-layer-press);}&:active ", "{box-shadow:2px 2px 4px 4px var(--aui-fills-actions-pressed-shadow) inset;}"], StateLayer, StyledContainer));
export const MicroAction = ({
  children,
  ...props
}) => {
  const hasAction = !!props.href || !!props.onClick;
  return /*#__PURE__*/React.createElement(StyledTouchBox, _extends({
    "data-aui": "action.micro",
    as: props.href ? 'a' : props.onClick ? 'button' : 'div',
    $hasAction: hasAction
  }, props), /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(DefaultsProvider, {
    value: {
      iconSize: 'large',
      iconFill: 'currentColor'
    }
  }, /*#__PURE__*/React.createElement(StateLayer, null), children)));
};